import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TrustContentModule } from '../../../pipes/trust-content/trust-content.module';
import { LinkComponent } from './link.component';

@NgModule({
  imports: [CommonModule, TrustContentModule],
  declarations: [LinkComponent],
  exports: [LinkComponent]
})
export class LinkModule {}
